import axios from 'axios';

export function getTermEntities() {
    return axios({
        method: 'GET',
        url: '/api/v1/terms/entities',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/cargoes/terms.js